import { render, staticRenderFns } from "./CarEdit.vue?vue&type=template&id=2ce1edbe"
import script from "./CarEdit.vue?vue&type=script&lang=ts"
export * from "./CarEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports